import React from "react";

const Close = props => (<svg width={props.width} height={props.height} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 20L20 1M1 1L20 20L1 1Z" stroke="#f1f1f1" strokeOpacity="0.8" strokeLinecap="round" strokeLinejoin="round" /></svg>)
export default Close
